@tailwind base;
@tailwind components;
@tailwind utilities;

@layer base {
  :root {
    color-scheme: light;
  }

  html {
    scroll-behavior: smooth;
    -webkit-text-size-adjust: 100%;
  }

  body {
    @apply bg-canvas-50 font-sans text-brand-950 antialiased;
    margin: 0;
    min-height: 100vh;
  }

  h1,
  h2,
  h3,
  h4 {
    @apply font-display font-extrabold tracking-tight text-brand-950;
  }

  a {
    @apply transition-colors;
  }

  :focus-visible {
    @apply outline-none ring-2 ring-brand-500 ring-offset-2 ring-offset-white;
  }
}

@layer components {
  .section-shell {
    @apply container py-16 sm:py-20 lg:py-24;
  }

  .eyebrow {
    @apply inline-flex items-center gap-2 rounded-full bg-brand-50 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-brand-700;
  }

  .card-surface {
    @apply rounded-3xl border border-canvas-300/70 bg-white shadow-card transition-all duration-300;
  }

  .card-surface-hover {
    @apply hover:-translate-y-1 hover:border-brand-200 hover:shadow-card-hover;
  }
}

@layer utilities {
  .text-balance {
    text-wrap: balance;
  }

  .no-scrollbar::-webkit-scrollbar {
    display: none;
  }

  .no-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
}
